import { KeyboardShortcut } from './keyboardShortcut/keyboardShortcut';
import { DebugHelper } from "@/helper/debugHelper";

export class ShortcutManager
{
    // キーボードショートカット情報
    private keyboardShortcutArray : Array<KeyboardShortcut> = new Array();

    public getCount() { return this.keyboardShortcutArray.length; }

    // キーボードショートカットを追加
    public addKeyboardShortcut(id : string, modifier : string, key : string, callback : () => void, canExecute : () => boolean)
    {
        var modifierNum = 0;
        if(modifier != "")
        {
            var modifiers = modifier.split("+");
            for(var mo of modifiers)
            {
                // スペースを削除
                var fix = mo.replace(/ /g , "");
                if(fix.toUpperCase() == "ctrl".toUpperCase() || fix.toUpperCase() == "cmd".toUpperCase())
                {
                    modifierNum += 1;
                }
                else if(fix.toUpperCase() == "shift".toUpperCase())
                {
                    modifierNum += 2;
                }
                else if(fix.toUpperCase() == "alt".toUpperCase())
                {
                    modifierNum += 4;
                }
            }
        }
        this.keyboardShortcutArray.push(new KeyboardShortcut(id, modifierNum, key.toLowerCase(), callback, canExecute));
    }

    // キーボードショートカットを削除
    public removeKeyboardShortcut(id : string)
    {
        // IDが重複している可能性があるので、繰り返す
        var loop = true;
        while (loop)
        {
            var removeIndex = -1;
            for(var i = 0; i < this.keyboardShortcutArray.length; ++i)
            {
                var item = this.keyboardShortcutArray[i];
                if(item.id == id)
                {
                    removeIndex = i;
                    break;
                }
            }

            if(removeIndex >= 0)
            {
                // 消去
                this.keyboardShortcutArray.splice(removeIndex, 1);
            }
            else
            {
                // 繰り返し終了
                loop = false;
            }
        }                                                                                                                                                                                                                   
    }

    // キーボードショートカットを実行する
    public doKeyboardShortcutIfNeeded(event : KeyboardEvent)
    {
        // キーを調べる
        var ctrl = event.ctrlKey || event.metaKey;
        var shift = event.shiftKey;
        var alt = event.altKey;
        var modifier = (ctrl ? 1 : 0) * 1 + (shift ? 1 : 0) * 2 + (alt ? 1 : 0) * 4;
        var key = event.key;
        DebugHelper.trace(key);

        // IE対応
        if(key.toUpperCase() == "LEFT") { key = "ArrowLeft"; }
        else if(key.toUpperCase() == "UP") { key = "ArrowUp"; }
        else if(key.toUpperCase() == "RIGHT") { key = "ArrowRight"; }
        else if(key.toUpperCase() == "DOWN") { key = "ArrowDown"; }
        else if(key.toUpperCase() === "DEL") { key = "delete"; }

        for(var item of this.keyboardShortcutArray)
        {
            if(item.key.toUpperCase() == key.toUpperCase() && item.modifier == modifier)
            {
                // 実行可能か?
                if(item.canExecute())
                {
                    // デフォルトイベントを実行させない
                    event.preventDefault();
                    // 実行する
                    item.callback();
                    break;
                }
            }
        }
    }
}
